import styled from "styled-components";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const ViewProjectContainer = styled.div`
  .header-collapse {
    display: flex;
    justify-content: end;
    margin: 8px;
    ${responsive.MOBILE`
      margin: 0 16px 0 0;
    `}
  }

  .accordion {
    margin: 24px 0;
    ${responsive.MOBILE`
      margin-bottom: 16px;
      margin-top: 16px;
    `}
  }

  .office-and-contact-details {
    margin: 20px 0;
    ${responsive.MOBILE`
      margin: 0px 0px 0px 0px;  
    `}
  }

  .status-label {
    padding: 24px 16px 0 16px;
    ${responsive.MOBILE`
      padding: 16px 8px;  
    `}
  }
  .activity-timeline {
    padding-top: 16px;
    .MuiGrid2-container {
      padding: 0px;
      margin-top: 0;
    }

    .filter-wrapper {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: flex-start;
      padding-bottom: 16px;
      padding-left: 16px;
      border-bottom: 1px solid ${COLORS.cirrus_black4};

      .add-activity-wrapper {
        margin-left: auto; /* Align this to the right */
        margin-right: 24px;
      }
      ${responsive.TABLET_PORTRAIT`
          align-items: flex-start; 
        `}
      ${responsive.MOBILE`
          padding-bottom: 16px;
          padding-left: 8px;
          .modality {
            margin-top: 0;
          }
        .add-activity-wrapper {
              width: 100%;
              margin-top: 16px;
              padding-right: 8px;
              margin-right: 0;
            button.MuiButton-root {
                width: 100%;
                display: block;
            }
          }
      `}
    }
  }
`;
